define('v3/Pages/Settings/ViewModels/Chat.ViewModel',[
	'knockout',
	'lodash',
	'env',
	'v3/Common/Services/Frontend/Frontend.Service',
	'v3/Common/Services/Backend/chatBackend'
],
function (ko, _, env, frontend, chatBackend) {
	function PupilViewModel (vm) {
		var self = this;
		self.userId = vm.userId;
		self.fullName = vm.name;
		self.pupilNameForSorting = vm.name;

		self.isSelected = ko.observable(true);
	}

	function ChatViewModel (options) {
		var self = this;

		self.navBackButtonParams = options.navBackButtonParams;
		self.isLoading = ko.observable(true);

		ko.computed(function () {
			var isLoading = self.isLoading();
			frontend.mask[isLoading ? 'show' : 'hide']();
		});

		self.pupils = ko.observableArray([]);

		chatBackend.getActiveChatUsers().done(function (pupils) {
			self.pupils(_.map(pupils, function (chatPupil) {
				return new PupilViewModel(chatPupil);
			}));

			self.isLoading(false);
		});

		self.hasPupilsSelected = ko.computed(function () {
			var hasSelected = false;
			_.each(self.pupils(), function (pupil) {
				if (pupil.isSelected()) {
					hasSelected = true;
				}
			});
			return hasSelected;
		});

		self.cancel = function () {
			_.each(self.pupils(), function (pupil) {
				pupil.isSelected(true);
			});
		};

		self.save = function () {
			frontend
				.confirm.show({
					content: Strings.DisableChatConfirmation,
					title: Strings.ConfirmSaveTitle,
					buttons: [Strings.DisableChatOkButton, Strings.CancelButton]
				})
				.then(function () {
					self.isLoading(true);

					var selectedPupilIds = _(self.pupils())
						.filter(function (pupil) {
							return pupil.isSelected();
						})
						.map(function (pupil) {
							return pupil.userId;
						})
						.value();

					chatBackend.deleteChannels(env.userInfo.classId, selectedPupilIds)
						.done(function () {
							window.location = self.navBackButtonParams.linkTemplate;
						})
						.fail(function () {
							self.isLoading(false);
						});
				});
		};
	}

	return ChatViewModel;
});
